import React from "react";

/**
 * クリックした日での履歴を特定する。
 * もしその履歴が無ければ（無いと思うが）、代わりに最新の履歴を表示する。
 * InstrumentとVehicleで重複コードになったのをフック関数化したもの
 * 
 * @param product fetchしたInstrumentやVehicleのデータ
 * @param itemId: 実際のところはborrowingId。product.historyのid
 * @returns 
 */
export const useTargetHistory = (product, itemId) => {
  return React.useMemo(() => {
    const latestHistory = product?.history[0];
    if (!product?.history) return latestHistory;  // historyは本当は複数なのでhistoriesにすべき（バックエンドとのインターフェース部分なのでおいそれと変えられない）

    if (itemId) {
      return product.history.find(h => h.id === parseInt(itemId)) || latestHistory;
    }

    return latestHistory;
  }, [product, itemId]);
};
